import React, { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MemoRow from './row';
import { updateUploadedGrid as updateG } from '../../../redux/shipperAdviceSlice';
import { calculateErrors } from './calculateerrors';

const Grid = ({grid, calltracks, reattempts}) => {
    const dispatch = useDispatch();
    const { services } = useSelector(state => state.appData);
    const state = useSelector(state => { return { appData: state.appData, shipperAdviceData: state.shipperAdviceData } });
    const { userInfo } = state.appData;
    
    const destRef = useRef(null);
    const {
        data,
        //grid
    } = state.shipperAdviceData;

    const updateGrid = (index, key, val) => {
        dispatch(updateG({ index, key, val }));
    };

    
    const ct = calltracks.map(e => e.text);
    const rt = reattempts.map(e => e.text);



    return <div className="row mt-2">
            <div className="table-responsive" style={{ maxHeight: "450px" }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Serial No</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Ticket No</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignment Number</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Shipper Advice</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Action Required</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Phone No</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Consignee Address</th>
                            <th className="th-sticky" style={{ background: "#f5f5f5" }}>Remarks</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            grid.map((x, index) => <MemoRow 
                                destRef={destRef} key={index} x={{ ...x, isCod: data.isCod }} 
                                formData={data} index={index} ct={ct} rt={rt}
                                user={userInfo} updateGrid={updateGrid} calltracks={calltracks} reattempts={reattempts}
                            />)
                        }
                    </tbody>
                </table>
            </div>
    </div>
}

export default Grid;
